/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

//export const getCurrentCloudHostingId = (state) => get(state, ['currentCloudHosting', 'items']);

export const getCurrentCloudHosting = (state) => {

    return get(state, ['currentCloudHosting', 'items'], []);
};

export const requestingCurrentCloudHosting = (state) => get(state, ['currentCloudHosting', 'requesting'], false);

export const errorRequestingCurrentCloudHosting = (state) => get(state, ['currentCloudHosting', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentCloudHosting,
    (currentCloudHosting) => {
        return get(currentCloudHosting, ['has_scheduled_changes'], false);
    },
);
